import classes from './Card.module.scss'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { CARD_TYPE } from '../../utils/constants';
import { CardText } from './CardText'; 
import { CardAudio } from './CardAudio';
import { CardImage } from './CardImage';
import { CardTextAudio } from './CardTextAudio';
import { CardTextImage } from './CardTextImage';
import { NAME_SOUND_HOVER, useGameSounds } from '@educaplay/core';

const dictionary = {
    [CARD_TYPE.CardText]: CardText,
    [CARD_TYPE.CardAudio]: CardAudio,
    [CARD_TYPE.CardImage]: CardImage,
    [CARD_TYPE.CardTextAudio]: CardTextAudio,
    [CARD_TYPE.CardTextImage]: CardTextImage
}

export function Card(props) {
    const { className, onClick, cardData, hasError, hasSuccess, isPressed, isPending, autoplay } = props;
    const Component = dictionary[cardData.cardType];

    const gameSound = useGameSounds();

    const componentClassName = clsx(classes.card, className, {
        [classes["card--error"]]: hasError,
        [classes["card--success"]]: hasSuccess,
        [classes["card--pressed"]]: isPressed,
        [classes["card--pending"]]: isPending
    })

    const isDisabled = hasError || hasSuccess;

    const onHover = () => {
        if(isDisabled) return;  
        gameSound.play(NAME_SOUND_HOVER);
    }

    const handlerClick = (e) => {
        if(isDisabled) return;
        onClick(e);
    }

    return (
        <div type='button' aria-disabled={isDisabled} className={componentClassName} onClick={handlerClick} onMouseEnter={onHover} role='button' tabIndex={0} >
            <Component cardData={cardData} isPressed={isPressed} autoplay={autoplay}></Component>
        </div>
    )
}

Card.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    hasError: PropTypes.bool,
    hasSuccess: PropTypes.bool,
    isPressed: PropTypes.bool,
    cardData: PropTypes.object.isRequired
}